import { lazyLoad } from 'utils/loadable';

export const DownloadPackages = lazyLoad(() => import('./index'));
